module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/murin6-180af6db2c94fdd00e31d509f1b1a9f0.jpg";